/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
const o=()=>{if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw new Error("No global object available")},e="kx_global_holder";export const getGlobalValue=l=>{const n=o();if(e in n)return n[e][l]};export const setGlobalValue=(l,n)=>{const t=o();let r;e in t?r=t[e]:(r={},t[e]=r),r[l]=n};